import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-11 13 24 24">
      <path
        d="M 2 3 L 2 5 L 6 5 L 6 3 L 2 3 z M 18 3 L 18 17 L 16 17 L 19 21 L 22 17 L 20 17 L 20 3 L 18 3 z M 2 7 L 2 9 L 8 9 L 8 7 L 2 7 z M 2 11 L 2 13 L 10 13 L 10 11 L 2 11 z M 2 15 L 2 17 L 12 17 L 12 15 L 2 15 z M 2 19 L 2 21 L 14 21 L 14 19 L 2 19 z"
        transform="translate(-11 13)"
      />
    </svg>
  ),
  'SortAscending',
  '0 0 24 24'
);
